/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, HostListener, HostBinding } from '@angular/core';
import { ChangedEvent, AlertKinds } from '@typescript-kit/core';
import { AlertModel } from '@typescript-kit/view';
import { BaseDirective } from '@angular-kit/view';

@Component({
  selector: 'kit-bs-alert',
  templateUrl: './bs-alert.component.html',
  styleUrls: ['./bs-alert.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BsAlertComponent extends BaseDirective<AlertModel> {
  @HostBinding('class.alert') kind: string;
  @HostBinding('class.alert-dismissible') isClosable: boolean;

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.model.onClick) {
      return;
      // if (this.model.onClick(event, this.model)) {
      //   event.preventDefault();
      //   return;
      // }
    }
    this.model.isPinned = !this.model.isPinned;
    event.preventDefault();
  }

  @HostListener('mouseenter', ['$event'])
  pauseTimeout(event: Event) {
    if (!this.model.isPinned) {
      this.clearTimeout(event);
    }
  }

  @HostListener('mouseleave', ['$event'])
  resumeTimeout(event: Event) {
    if (!this.model.isPinned) {
      this.setTimeout(event);
    }
  }

  clearTimeout(event: Event) {
    if (this.model.onClearTimeout) {
      this.model.onClearTimeout(this.model);
      event.preventDefault();
    }
  }

  setTimeout(event: Event) {
    if (this.model.onSetTimeout) {
      this.model.onSetTimeout(this.model);
      event.preventDefault();
    }
  }

  discard(event: Event) {
    if (this.model.onDiscard) {
      this.model.onDiscard(this.model);
      event.preventDefault();
    }
  }

  protected onModelChanged(model: AlertModel) {
    super.onModelChanged(model);
    this.refreshKind();
    this.refreshIsPinned();
    this.refreshIsClosable();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    if (event.changes['kind']) {
      this.refreshKind();
    }
    if (event.changes['isPinned']) {
      this.refreshIsPinned();
    }
    if (event.changes['isClosable']) {
      this.refreshIsClosable();
    }
  }

  private refreshKind() {
    const originalKind = this.kind;
    this.kind = this.getModelKind();
    if (this.kind === originalKind) {
      return;
    }
    if (originalKind) {
      this.removeClass(originalKind, 'alert-');
    }
    if (this.kind) {
      this.addClass(this.kind, 'alert-');
    }
  }

  private getModelKind(): string {
    if (!this.model || !this.model.kind) {
      return null;
    }
    return this.model.kind === AlertKinds.ERROR ? 'danger' : this.model.kind;
  }

  private refreshIsPinned() {
    if (!this.model || !this.model.isPinned) {
      this.removeClass('pinned', 'kit-alert-');
    } else {
      this.addClass('pinned', 'kit-alert-');
    }
  }

  refreshIsClosable() {
    this.isClosable = this.model && this.model.isClosable;
  }

}
